import type { CommuteMode } from '../../../../../../redux/features/jobFormSlice';

type FormatMessage = (descriptor: { id: string; defaultMessage: string; description?: string }, values?: Record<string, string | number>) => string;

/** "24 min" / "1 h 5 min", shared by the map chip and the map modal's travel strip. */
export function formatCommuteMinutes(formatMessage: FormatMessage, minutes: number): string {
  if (minutes < 60) {
    return formatMessage({ id: 'jobDetailPageV2.homeCommute.minutes', defaultMessage: '{minutes} min', description: 'Commute duration under an hour on the job page' }, { minutes });
  }
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest === 0
    ? formatMessage({ id: 'jobDetailPageV2.homeCommute.hours', defaultMessage: '{hours} h', description: 'Commute duration in whole hours on the job page' }, { hours })
    : formatMessage({ id: 'jobDetailPageV2.homeCommute.hoursMinutes', defaultMessage: '{hours} h {minutes} min', description: 'Commute duration over an hour on the job page' }, { hours, minutes: rest });
}

/** The travel-mode name as the map's commute panel already calls it. */
export function commuteModeLabel(formatMessage: FormatMessage, mode: CommuteMode): string {
  switch (mode) {
    case 'transit':
      return formatMessage({ id: 'map.commute.profile.transit', defaultMessage: 'Transit' });
    case 'driving':
      return formatMessage({ id: 'map.commute.profile.driving', defaultMessage: 'Drive' });
    case 'cycling':
      return formatMessage({ id: 'map.commute.profile.cycling', defaultMessage: 'Bike' });
    default:
      return formatMessage({ id: 'map.commute.profile.walking', defaultMessage: 'Walk' });
  }
}
